export default "__VITE_ASSET__Xxp2BuTt__"